import * as React from 'react';
import { Progress } from 'antd';
import { METRIC_SWITCH_MAP, getMetricDisplayName, getMetricShortName } from '@utils/metrics';
import useSetSummaryExport from '@components/top-widget-panel/spi-panel/hooks/useSetSummaryExport';
import { getMetricTitle, sortKPIMetricsData } from './utils';
import {
  IOCategoryWrapper,
  IOItemContentWrapper,
  IOItemTitleWrapper,
  IOItemValueWrapper,
  IOWidgetWrapper,
} from './styled';
import { RED_COLOR } from '../constants';

const ImprovementOpportunitiesWidget = ({
  data = {},
  selectedChartMetric,
  onWidgetCardClick: onMetricBarClick,
  metricList,
}) => {
  const metricsArrayCategory = sortKPIMetricsData(data) || [];

  useSetSummaryExport({
    totals: data,
    category: {
      name: 'Improvement Opportunities',
      metrics: metricList,
    },
  });

  return (
    <IOWidgetWrapper>
      <IOCategoryWrapper>
        {metricsArrayCategory.map(({ name, value }) => {
          const displayName = getMetricDisplayName({ metricKey: name });
          const short = getMetricShortName({ metricKey: name, hasSubscript: false });
          return (
            <IOItemContentWrapper
              title={displayName}
              key={name}
              onClick={
                value !== undefined
                  ? () => onMetricBarClick(METRIC_SWITCH_MAP[name], value)
                  : undefined
              }
              isClickable={value !== undefined}
              highlight={METRIC_SWITCH_MAP[name] === selectedChartMetric}
            >
              <IOItemTitleWrapper>{short}</IOItemTitleWrapper>
              <IOItemValueWrapper>{getMetricTitle(name, value)}</IOItemValueWrapper>
              <Progress
                percent={value}
                strokeColor={RED_COLOR}
                style={{ margin: 0, padding: 0, width: '100px', top: '-1px' }}
                type="line"
                strokeWidth={7}
                size="small"
                showInfo={false}
              />
            </IOItemContentWrapper>
          );
        })}
      </IOCategoryWrapper>
    </IOWidgetWrapper>
  );
};

export default ImprovementOpportunitiesWidget;
